import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'

class BannerFromConfig extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.number,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    backgroundColor: PropTypes.string,
    inheritBannerStyles: PropTypes.bool,
    height: PropTypes.number,
  }

  static defaultProps = {
    inheritBannerStyles: true,
    backgroundColor: '#000',
  }

  render() {
    return (
      <div
        className={classNames(this.props.className, {
          banner: this.props.inheritBannerStyles,
        })}
        style={{
          height: this.props.height,
          backgroundColor: this.props.backgroundColor,
          height: this.props.height,
        }}
      >
        {this.props.children}
      </div>
    )
  }
}

BannerFromConfig.MOBILE_HEIGHT = 40
BannerFromConfig.DESKTOP_HEIGHT = 36

export default BannerFromConfig
